import {LABELS} from '@github-ui/timeline-items/Labels'
import {KebabHorizontalIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, IconButton} from '@primer/react'

import styles from './LoadDirectionPicker.module.css'

type LoadDirectionPickerProps = {
  loadFromTopFn: () => void
  loadFromBottomFn: () => void
  isLoading: boolean
  setIsHovering: (hovering: 'top' | 'bottom' | undefined) => void
  type: 'load-top' | 'load-bottom'
  newestFirst?: boolean
}

export const LoadDirectionPicker = ({
  loadFromTopFn,
  loadFromBottomFn,
  isLoading,
  setIsHovering,
  type,
  newestFirst = false,
}: LoadDirectionPickerProps) => (
  <div className={styles.directionPickerContainer}>
    <ActionMenu>
      <ActionMenu.Anchor>
        <IconButton
          inactive={isLoading}
          aria-disabled={isLoading}
          size="small"
          icon={KebabHorizontalIcon}
          data-testid={`issue-timeline-load-more-options-${type}`}
          variant="invisible"
          aria-label="Load more actions"
        />
      </ActionMenu.Anchor>
      <ActionMenu.Overlay>
        <ActionList className={styles.ActionList}>
          <ActionList.Item
            disabled={isLoading}
            onSelect={loadFromTopFn}
            onMouseEnter={() => setIsHovering('top')}
            onMouseLeave={() => setIsHovering(undefined)}
          >
            <span>{newestFirst ? LABELS.timeline.loadNewer : LABELS.timeline.loadOlder}</span>
          </ActionList.Item>
          <ActionList.Item
            disabled={isLoading}
            onSelect={loadFromBottomFn}
            onMouseEnter={() => setIsHovering('bottom')}
            onMouseLeave={() => setIsHovering(undefined)}
          >
            <span>{newestFirst ? LABELS.timeline.loadOlder : LABELS.timeline.loadNewer}</span>
          </ActionList.Item>
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  </div>
)
